import type { AssemblyResponseDTO, ParentAssembly } from '@luminovo/api-contracts';

/**
 * The only direct child a top-level assembly's BOM opens on instead of a one-row table, or `undefined` to stay put.
 * Loaders read `assembly` (`POST /assemblies/bulk`) and `parents`, its paths from the BOM, with the BOM page's queries.
 * They write `assembly` as the child's `currentParentAssemblyId` so the breadcrumb keeps its depth: `subassemblies`
 * lists direct children only.
 */
export function singleSubassemblyOf(
    assembly: AssemblyResponseDTO | undefined,
    parents: ParentAssembly[][],
): string | undefined {
    const children = assembly?.subassemblies.items ?? [];
    // Top-level: the first of its paths from the BOM holds it alone.
    return (parents[0] ?? []).length === 1 && children.length === 1 ? children[0].assembly_id : undefined;
}
